import { IAddress } from "./PersonalInfo";

export interface IFilerInformation {
  filerName: string;
  nric: string;
  email: string;
  mobile: string;
  filerAddress: IAddress;
  uen: string;
  companyName: string;
}

export const tempFilerInfo: IFilerInformation = {
  filerName: "",
  nric: "",
  email: "",
  mobile: "",
  filerAddress: {
    postalCode: "",
    blockHouseNo: "",
    streetName: "",
    country: "",
    floorLevel: "",
    unit: "",
    buildingName: "",
  },
  uen: "",
  companyName: "",
};
